import { makeStyles } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import React from 'react';

const useStyles = makeStyles(() => ({
  alert: {
    '&.MuiAlert-root': {
      fontFamily: 'Roboto',
      backgroundColor: '#ff9800',
    },
    '&>.MuiAlert-message': {
      color: '#fff',
      fontWeight: 500,
      backgroundColor: '#ff9800',
    },
    '&>.MuiAlert-icon': {
      color: '#fff',
    },
    flex: 1,
    marginBottom: '10px',
  },
}));

const NotificacaoSistema = (props) => {
  const classes = useStyles(props);

  return (
    <>
      {props.exibir && (
        <Alert severity="warning" className={classes.alert}>
          {props.children}
        </Alert>
      )}
    </>
  );
};

export default NotificacaoSistema;
